var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`icon_remuneration`, _vm.className || ``]},[_c('img',{staticClass:"business-credit-card",attrs:{"src":require("../../img/business---credit-card@2x.png"),"alt":"Business / credit card"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }